import CheckBrowser from './checkBrowser';
export default CheckBrowser;
